import { InputAdornment as MuiInputAdornment } from '@mui/material';
import type { InputAdornmentProps as MuiInputAdornmentProps } from '@mui/material/InputAdornment';

export type InputAdornmentProps = MuiInputAdornmentProps;

export const InputAdornment = ({ ...rest }: InputAdornmentProps): JSX.Element => (
  <MuiInputAdornment {...rest} />
);
